import { useContext, useCallback } from 'react';
import { Context } from '../context/AppContext';

function useDataLayerPush() {
  const { user: { user: { id: userId } = {} } = {} } = useContext(Context);

  const dataLayerPush = useCallback(
    (data, skipOptimizely = false) => {
      const loginStatus = userId ? 'authenticated' : 'unauthenticated';

      const dataLayerObject = {
        login_status: loginStatus,
        user_id: userId || undefined,
        hostname: window.location.hostname,
        page_url: window.location.href,
        referrer: document.referrer,
        page_type: window.location.pathname,
        ...data,
      };

      window.PageDataLayer = window.PageDataLayer || [];
      window.PageDataLayer.push(dataLayerObject);

      if (!skipOptimizely) {
        window.optimizely = window.optimizely || [];
        const { event, eventName, ...tags } = dataLayerObject;
        window.optimizely.push({
          type: 'event',
          eventName: eventName || event,
          tags,
        });
      }
    },
    [userId]
  );

  return { dataLayerPush };
}

export default useDataLayerPush;
